import type { Vector3 } from "three";

import type { WorldObjectAPI } from "./WorldObject";

export interface PickableWorldObject extends WorldObjectAPI {
  onPicked(hitPoint: Vector3): void;
  onUnpicked?(): void;
  onHover?(hitPoint: Vector3): void;
  onUnhover?(): void;
}

export function isPickableWorldObject(
  worldObject: WorldObjectAPI
): worldObject is PickableWorldObject {
  return "onPicked" in worldObject;
}
